import Users from "screens/private/users";
export default Users;
